<div class="sourcing-needs-container">
    <div class="sourcing-needs-card">

        <!-- Left Menu Panel -->
        <div class="menu-panel">
            <div class="menu-header">
                <h2>Options</h2>
            </div>

            <nav class="menu-nav">
                <div *ngFor="let item of menuItems" (click)="selectTab(item.key)"
                    [class.active]="item.key === activeTab" class="menu-item">
                    <span
                        style="margin-right: 8px; display: flex; align-items: center; justify-content: center; width: 20px; height: 20px;">
                        <img *ngIf="item.image" [src]="item.image"
                            style="width: 100%; height: 100%; object-fit: cover;">
                        <span *ngIf="!item.image" style="font-size: 20px; line-height: 1;">{{ item.emoji }}</span>
                    </span>
                    <span *ngIf="item.name !== 'Overview'"
                        [style.background-color]="getItemStatus(item.key) ? '#52c41a' : '#d9d9d9'"
                        style="width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 8px;">
                    </span>
                    <span *ngIf="item.name == 'Overview'"
                        style="width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 8px;">
                    </span>
                    <span>{{ item.name }}</span>
                </div>
            </nav>
        </div>

        <!-- Main Content Area -->
        <div class="content-panel scrollable-panel">

            <!-- Overview Tab Content -->
            <div *ngIf="activeTab === 'overview'">
                <app-overview-component [sourcingNeedData]="sourcingNeedData" [allDataAvailable]="true"
                    [outsourcingTypesList]="outsourcingTypesList">
                </app-overview-component>
            </div>

            <!-- Regular Tab Content -->
            <div *ngIf="activeTab !== 'overview'">
                <div class="content-header" style="display: flex;">
                    <!-- <h1>{{ getActiveTabName() }}</h1> -->
                    <span style="display: flex;gap: 15px;align-items: center;">
                        <h3>Is {{ getActiveTabName() }} needed?</h3>
                        <div class="actions">
                            <nz-switch
                                [ngModel]="getRequirementValueForActiveTab()"
                                (ngModelChange)="onRequirementToggle($event)"
                                [nzDisabled]="getRequirementValueForActiveTab()"
                                nzCheckedChildren="Yes"
                                nzUnCheckedChildren="No">
                            </nz-switch>
                        </div>
                    </span>
                </div>

                <!-- Dynamic Form Content -->
                <div class="form-content scrollable-content">

                    <!-- State 3: Data Exists (View Mode) -->
                    <div *ngIf="isView">
                        <app-common-sourcing-view [data]="getDataForActiveTab()" [config]="getViewConfig()"
                            [title]="getActiveTabName()" (onEdit)="onEdit()" (onDelete)="onDelete()">
                        </app-common-sourcing-view>
                    </div>


                    <div *ngIf="!isView" class="full-screen-center">
                        <div class="minimal-banner-container">
                            <p class="minimal-banner-text">
                                ⚠️ Please enable the option to add or view details.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>

<!-- Modal for Forms -->
<nz-modal [(nzVisible)]="isModalVisible" [nzTitle]="modalTitle" (nzOnCancel)="onModalXClick()" [nzFooter]="null"
    [nzWidth]="1000" [nzBodyStyle]="{ 'max-height': '600px', 'overflow-y': 'auto' }">
    <ng-container *nzModalContent>
        <ng-container [ngSwitch]="activeTab">
            <app-sn-form-av-v2 *ngSwitchCase="'av'" [eventId]="souringNeedId" [data]="avData"
                (closeModal)="onModalClosed($event)">
            </app-sn-form-av-v2>

            <!-- Other components will be added here as they are refactored -->
            <app-sn-form-venue-v2 *ngSwitchCase="'venue'" [eventId]="souringNeedId" [sourcingNeedRecordId]="sourcingNeedData?.id || null" [data]="venueData"
                (closeModal)="onModalClosed($event)"></app-sn-form-venue-v2>
            <app-sn-form-catering-v2 *ngSwitchCase="'catering'" [eventId]="souringNeedId" [data]="cateringData"
                (closeModal)="onModalClosed($event)"></app-sn-form-catering-v2>
            <app-sn-form-photo-video-v2 *ngSwitchCase="'photographer'" [eventId]="souringNeedId" [data]="photoVideoData"
                (closeModal)="onModalClosed($event)"></app-sn-form-photo-video-v2>
            <app-sn-form-branding-v2 *ngSwitchCase="'branding'" [eventId]="souringNeedId" [data]="brandingData"
                (closeModal)="onModalClosed($event)"></app-sn-form-branding-v2>
            <app-sn-form-gift-v2 *ngSwitchCase="'gift'" [eventId]="souringNeedId" [data]="giftData"
                (closeModal)="onModalClosed($event)"></app-sn-form-gift-v2>
            <app-sn-form-transport-v2 *ngSwitchCase="'transport'" [eventId]="souringNeedId" [data]="transportData"
                (closeModal)="onModalClosed($event)"></app-sn-form-transport-v2>
            <app-sn-form-speaker-talent-v2 *ngSwitchCase="'speaker'" [eventId]="souringNeedId" [data]="speakerData"
                (closeModal)="onModalClosed($event)"></app-sn-form-speaker-talent-v2>
            <app-sn-form-furniture-v2 *ngSwitchCase="'furniture'" [eventId]="souringNeedId" [data]="furnitureData"
                (closeModal)="onModalClosed($event)"></app-sn-form-furniture-v2>
            <app-sn-form-experience-v2 *ngSwitchCase="'experience'" [eventId]="souringNeedId" [data]="experienceData"
                (closeModal)="onModalClosed($event)"></app-sn-form-experience-v2>
            <app-sn-form-production-fabrication-v2 *ngSwitchCase="'productionFabrication'" [eventId]="souringNeedId" [data]="productionFabricationData"
                (closeModal)="onModalClosed($event)"></app-sn-form-production-fabrication-v2>
        </ng-container>
    </ng-container>
</nz-modal>